import emailjs from 'emailjs-com'

import { ContactContainer, 
    ContactH1, 
    BtnWrap, 
    ContactWrapper, 
    ContactCard, 
    Form,
    TextArea,
    Location,
    ContactSubTitle,
    DirectContactDetailsWrapper
 } from "./ContactElements"
import { Button } from "../ButtonElement"
import { FaArrowRight, FaPhoneSquareAlt, FaEnvelopeOpen } from "react-icons/fa"
import Resume from "../../Assets/resume.pdf"

const Contact = () => {
    function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm('service_0gmuip2', 'template_8dmvlrf', e.target, 'user_0wpcjI15aSwsepdY0IfIa')
          .then((result) => {
              console.log(result.text);
              alert('Your message has been sent successfully!');
          }, (error) => {
              console.log(error.text);
          });

          e.target.reset()
      }

   return <ContactContainer id = "contact">
       <ContactH1>
           &emsp;
           Get In Touch
           &emsp;
           <DirectContactDetailsWrapper>
           <ContactSubTitle href="tel:+91-9961438548" target = "_blank"><FaPhoneSquareAlt />&ensp;+91-9961438548&ensp;</ContactSubTitle> | 
           <ContactSubTitle href="mailto: kiranjolisa@gmail.com" target = "_blank">&ensp;<FaEnvelopeOpen />&ensp;kiranjolisa@gmail.com</ContactSubTitle>
           </DirectContactDetailsWrapper>
       </ContactH1>
       <ContactWrapper>
            <ContactCard>
                <Form onSubmit = {sendEmail}>
                    <input type = "text" name = "from_name" required placeholder= "Your Name Please" />
                    <br />
                    <input type = "email" name = "user_email" required placeholder= "Email" />
                    <br />
                    <TextArea name = "message" placeholder = "Your message" required/>
                    <br />
                    <input type = "submit" value = "SEND MESSAGE" />                    
                </Form>
                <BtnWrap>
                <Button 
                        href = {Resume}
                        primary = "true"
                        dark = "true"
                        target = "_blank"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            SHOW RESUME<FaArrowRight/>
                </Button>
                </BtnWrap>
            </ContactCard>
            <ContactCard>
                <Location />
            </ContactCard>
        </ContactWrapper>
   </ContactContainer>
}

export default Contact